import { defineStore } from 'pinia'
import getLocalDesignerApi from '~/composables/api/localDesignerApi'
import type { LocalDesigner, GalleryLocalDesigner } from '~/models/designer.model'

export const useLocalDesignerStore = defineStore('storeLocalDesigner', {
  state: () => ({
    designer: null as LocalDesigner | null,
    galleryLD: [] as GalleryLocalDesigner,
  }),
  actions: {
    async getDesigner(slug: string) {
      const response = (await getLocalDesignerApi.getDesigner(slug)).data.value
      if (response?.data) {
        this.setDataDesigner(response?.data)
      }
    },
     // Mutations
     setDataDesigner(response: LocalDesigner) {
      this.designer = response
    },
    setGalleryLDData(response: GalleryLocalDesigner) {
      this.galleryLD = response
    },
  },
})
